import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterdata'
})
export class FilterdataPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): unknown {
    if(value){
      return value.filter(
        value => value.isShow == true);
    }
}
  }

